export const animationSettings = {
  fs_add: {
    'default': ['static'],
    'STATE:IN:FS-ADD': ['play', false, 'start', { name: 'IN-END-DONE', delay: 3.5 }],
  },
  fs_end: {
    'default': ['static'],
    'STATE:IN:WIN': ['play', false],
  },
  reel: {
    'default': ['static'],
    'WIN-ANIMATE:DONE': ['play', false, 'reel-decor-general'],
    'RESPIN-INTRO-ANIM': ['play', false, 'reel-react-on-delorean'],
  },
  logo: {
    'default': ['static'],
    'TEST': ['play', false],

    'STATE:IN:WIN': ['play', false],
  },
}
